import { AppState, HomePageBerlinAppState } from '../../../initialStateRegistration';
import { SectionNames, HomePageBerlinMinorSections, HomePageBerlinImageLinksSection } from './homePageBerlin.initialState';

export const getHomePage = (state: AppState) => (state as HomePageBerlinAppState).template;

export const getSectionDataByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key];

export const getSectionArticlesByKey = (key: SectionNames) => (state: AppState) => getHomePage(state)[key].articles;

export const getSectionTitleByKey = (key: SectionNames | HomePageBerlinImageLinksSection) => (state: AppState) => getHomePage(state)[key].sectionTitle;

export const getSectionImageLinks = (key: HomePageBerlinImageLinksSection) => (state: AppState) => getHomePage(state)[key].imageLinks;

export const getMoreButtonTextByKey = (key: HomePageBerlinMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonText;

export const getMoreButtonSvgByKey = (key: HomePageBerlinMinorSections) => (state: AppState) => getHomePage(state)[key].moreButtonSvg;

export const getMetadataDescription = (state: AppState) => getHomePage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getHomePage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getHomePage(state).metadataImage;

export const getHreflangData = (state: AppState) => getHomePage(state).hreflangData;
